import React from "react";
import { useRouter } from "next/router";

import Badge from "../Badge";
import { Image } from "../../../../components/Atoms";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import {
  Div,
  ImageBanner,
  ImageList,
  StyledAvatar,
  StyledCard,
  StyledCta,
  TextBox,
} from "../style";
import { mapDoctorList } from "../../mapWebinarListPageData";

function WebinarCard({ item }) {
  const router = useRouter();

  return (
    <StyledCard grayedOut={item?.tag?.toLowerCase() === "upcoming"}>
      {item?.tag && <Badge type={item?.tag.toLowerCase()} />}
      <ImageBanner>
        {item?.cover_image && <Image src={item?.cover_image} />}
      </ImageBanner>
      <TextBox flex="1">
        <Typography
          mb={"16px"}
          textAlign="center"
          color={theme.colorsV2.gray.shade_800}
          variant="heading5"
          flex="1"
        >
          {item?.title}
        </Typography>
        {item?.trainer_details?.length > 0 && (
          <ImageList>
            {item?.trainer_details?.map((image, index) => {
              return (
                <StyledAvatar
                  key={`${image.name}-${index}`}
                  hasBoxShadow
                  hideHighlights
                  flexDirection="column"
                  {...mapDoctorList(image)}
                />
              );
            })}
          </ImageList>
        )}
        <Div flexDirection={"column"} mb="24px">
          <Typography
            textAlign="center"
            color={theme.colorsV2.primary.shade_800}
            variant="label3"
            mb="8px"
          >
            {item?.date}
          </Typography>
          <Typography
            textAlign="center"
            color={theme.colorsV2.primary.shade_800}
            variant="label3"
          >
            {item?.time}
          </Typography>
        </Div>
        {item?.cta && (
          <Div justifyContent="center">
            <StyledCta
              bgColor={theme.colorsV2.blueGray.shade_50}
              hoverColor={theme.colorsV2.blueGray.shade_50}
              variant="primary1"
              fontFamily={"var(--man-700)"}
              btnPadding={"15px 32px"}
              fontSize={["14px", "15px", "16px"]}
              width="100%"
              maxWidth="231px"
              version={"v2"}
              TextColor={theme.colorsV2.blueGray.shade_400}
              disabled={item?.tag?.toLowerCase() === "upcoming"}
              onClick={() =>
                item?.tag?.toLowerCase() !== "upcoming" && item?.page_slug
                  ? router.push(item?.page_slug)
                  : {}
              }
            >
              {item?.cta}
            </StyledCta>
          </Div>
        )}
      </TextBox>
    </StyledCard>
  );
}

export default WebinarCard;
